"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Account = void 0;
const server_sdk_1 = require("@air/server-sdk");
const types_1 = require("@air/types");
const request_1 = require("./request");
const util_1 = require("./util");
/**
 * Returns account information
 * The workspace parameter returns an empty array if account has no workspaces
 */
function get() {
    return (0, request_1.airRequest)(types_1.EndpointType.accounts);
}
/**
 * Creates a new account, for users joining a workspace stores their stated occupation.
 * @param newAccount Account information
 * @param onboardingData Object containing survey question for user occupation,
 * this should only be provided for users joining an existing workspace (not a user creating their first workspace).
 */
function create(newAccount, onboardingData) {
    return (0, request_1.airRequest)(types_1.EndpointType.accounts, {
        method: 'POST',
        body: { newAccount, onboardingData },
    });
}
/**
 *
 * @param updatedAccount Object with fields to update: firstName, lastName, avatar (base64 string representation as with workspace)
 * @returns authId cognito id
 * @returns firstName first name
 * @returns lastName last name
 * @returns avatar imgix url to image
 */
function update(updatedAccount) {
    return (0, request_1.airRequest)(types_1.EndpointType.accounts, {
        endpoint: 'update',
        method: 'POST',
        body: updatedAccount,
    });
}
function verify(encrypted) {
    return (0, request_1.airRequest)(types_1.EndpointType.accounts, {
        endpoint: `verify`,
        method: 'POST',
        body: {
            encrypted,
        },
        authorized: false,
    });
}
/**
 * deletes the authed user account and removes their cognito record
 * NOTE - This will only work in dev
 */
function del() {
    return (0, request_1.airRequest)(types_1.EndpointType.accounts, {
        method: 'DELETE',
    });
}
function listApprovedWorkspaces() {
    return __awaiter(this, arguments, void 0, function* (args = {}) {
        return (0, request_1.airRequest)(types_1.EndpointType.accounts, {
            method: 'GET',
            endpoint: `approvedworkspaces`,
        });
    });
}
/**
 * This is a legacy endpoint that only includes workspace SAML.
 * @deprecated This has been replaced by getAccountSSOOptionsV2
 */
function getAccountSSOOptions(email) {
    return __awaiter(this, void 0, void 0, function* () {
        return (0, request_1.airRequest)(types_1.EndpointType.accounts, {
            method: 'GET',
            endpoint: `ssoOptions?${(0, util_1.formatParamsForHttp)({ email })}`,
            authorized: false,
        });
    });
}
/* This is a new endpoint that includes organization SAML */
function getAccountSSOOptionsV2(args) {
    return __awaiter(this, void 0, void 0, function* () {
        const listSSOOptionsSdk = server_sdk_1.Accounts.SSOOptions.list;
        return (0, request_1.airRequest)(listSSOOptionsSdk, {
            body: args,
            returnErrors: true,
            authorized: false,
        });
    });
}
function createApiKey(request) {
    return __awaiter(this, void 0, void 0, function* () {
        return (0, request_1.airRequest)(types_1.EndpointType.accounts, {
            method: 'POST',
            endpoint: `apikeys`,
            body: request,
        });
    });
}
function deleteApiKey(id, hardDelete) {
    return __awaiter(this, void 0, void 0, function* () {
        return (0, request_1.airRequest)(types_1.EndpointType.accounts, {
            method: 'DELETE',
            endpoint: `apikeys/${id}?${(0, util_1.formatParamsForHttp)({ hardDelete })}`,
        });
    });
}
function listApiKeys() {
    return __awaiter(this, void 0, void 0, function* () {
        return (0, request_1.airRequest)(types_1.EndpointType.accounts, {
            method: 'GET',
            endpoint: `apikeys`,
        });
    });
}
exports.Account = {
    get,
    create,
    update,
    verify,
    del,
    listApprovedWorkspaces,
    getAccountSSOOptions,
    getAccountSSOOptionsV2,
    createApiKey,
    deleteApiKey,
    listApiKeys,
};
//# sourceMappingURL=account.js.map